import { useFragment } from '@apollo/client/react'
import { LoadingSkeleton } from '@/components/base/loading-skeleton'
import { graphql } from '@/gql'
import { Text } from '@/components/base/text'

export const DeviceFragment = graphql(`
  fragment DeviceDetail on DeviceType {
    id
    name
    dateFormat
    svg
    panelConnectors { id label offsetX offsetY connector { id name svg connectorPins { id svg connectorFamilyPin { id name role } } } }
  }
`)

interface Props {
  id: string
}

export const Device = ({ id }: Props) => {
  const { data, complete } = useFragment({
    fragment: DeviceFragment,
    from: { __typename: 'DeviceType', id },
  })

  if (!complete) return <LoadingSkeleton table />

  return (
    <>
      { data && <div className="flex flex-col grow">
        <Text>Boo</Text>
        <div dangerouslySetInnerHTML={{ __html: (data.svg || '').replace('</svg>', data.panelConnectors.reduce((connectors, panelConnector) => connectors + `<g transform="translate(${panelConnector.offsetX} ${panelConnector.offsetY})">${panelConnector.connector.svg.replace('</svg>', panelConnector.connector.connectorPins.reduce((acc, pin) => acc + pin.svg, ''))}</g>`, '') + '</svg>') }} />

      </div> }
    </>
  )
}
